import { render, staticRenderFns } from "./votePaiHang.vue?vue&type=template&id=27b65d0b"
import script from "./votePaiHang.vue?vue&type=script&lang=js"
export * from "./votePaiHang.vue?vue&type=script&lang=js"
import style0 from "./votePaiHang.vue?vue&type=style&index=0&id=27b65d0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports